import APIProxy from '@/org-app/api';

interface IPackageCustomPropertyApi {
  key: string;
  type: string;
  source: string;
  label: string;
  placeholder: string;
}

export default class PackageCustomProperty {
  key: string;
  type: string;
  source: string;
  label: string;
  placeholder: string | null;
  value: unknown;
  isSearching: boolean;
  sourceData: unknown[];

  constructor(key: string, type: string, source: string, label: string, placeholder: string = null) {
    this.key = key;
    this.type = type;
    this.source = source;
    this.label = label;
    this.placeholder = placeholder;
    this.value = null;
    this.isSearching = false;
    this.sourceData = null;
    switch (this.type) {
      case 'list':
        this.loadData();
        break;
      case 'search':
        this.sourceData = [];
        break;
      default:
        break;
    }
  }

  async loadData(): Promise<unknown[]> {
    if (this.sourceData != null) {
      return this.sourceData;
    }
    this.sourceData = await APIProxy.instance.axiosInstance.get(this.source).data;
    return this.sourceData;
  }

  async search(term: string): Promise<unknown[]> {
    if (this.source == null || term.trim().length < 3) {
      return [];
    }
    this.isSearching = true;
    const response = await APIProxy.instance.axiosInstance.get(this.source.replace('{0}', term));
    this.sourceData =
      response.data == null
        ? []
        : Object.entries(response.data)
            .map((x) => ({ id: x[0], name: x[1] }))
            .sort((a, b) => (a.name as string).localeCompare(b.name as string));
    this.isSearching = false;
    return this.sourceData;
  }

  static fromApi(apiObject: IPackageCustomPropertyApi): PackageCustomProperty {
    return new PackageCustomProperty(
      apiObject.key,
      apiObject.type,
      apiObject.source,
      apiObject.label,
      apiObject.placeholder,
    );
  }

  toApi(): IPackageCustomPropertyApi {
    return {
      key: this.key,
      type: this.type,
      source: this.source,
      label: this.label,
      placeholder: this.placeholder,
    };
  }
}
